import { OfficeRecord } from "@graphql/types/graphql";
import { IOfficeLocation } from "@types";

export const convertOfficesToGeoJson = (offices: OfficeRecord[]): GeoJSON.FeatureCollection => {
  const features: GeoJSON.Feature[] = [];

  offices.forEach((office) => {
    office.officeLocations?.forEach((location) => {
      // Type assertion to fix type incompatibility
      const loc = location as IOfficeLocation; // Dirty fix for type safety
      const longitude = loc.officeAddress?.longitude;
      const latitude = loc.officeAddress?.latitude;

      if (longitude && latitude) {
        features.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [longitude, latitude],
          },
          properties: {
            id: location.id,
            externalLink: office.externalLink,
            title: office.title,
            address: loc.officeAddress?.display_name || "",
            addressSLug: location.slug,
            slug: office.slug,
          },
        });
      }
    });
  });

  const geoJSON: GeoJSON.FeatureCollection = {
    type: "FeatureCollection",
    features: [...features],
  };

  return geoJSON;
};
